// Swimlane board (Flow): lanes of cards. Cards are links or buttons — dragging never changes status (status only through gates).
import type { ReactNode } from "react";

export interface Lane<T> { id: string; title: ReactNode; subtitle?: ReactNode; items: T[] }

export function Swimlane<T>({ lanes, renderCard, cardKey, emptyText = "Nothing here" }: {
  lanes: Array<Lane<T>>; renderCard: (item: T) => ReactNode; cardKey: (item: T) => string; emptyText?: string;
}) {
  return (
    <div className="relative flex gap-3 overflow-x-auto pb-2" role="list" aria-label="Lanes">
      {lanes.map((l) => (
        <section key={l.id} role="listitem" aria-label={typeof l.title === "string" ? l.title : l.id} className="flex w-72 shrink-0 flex-col rounded-lg border border-line bg-sunken">
          <header className="border-b border-line px-3 py-2">
            <h3 className="text-sm font-semibold">{l.title} <span className="font-normal text-muted">· {l.items.length}</span></h3>
            {l.subtitle && <p className="text-xs text-muted">{l.subtitle}</p>}
          </header>
          <ul className="space-y-2 p-2">
            {l.items.length === 0 ? <li className="px-1 py-3 text-center text-xs text-muted">{emptyText}</li>
              : l.items.map((it) => <li key={cardKey(it)} className="rounded-md border border-line bg-raised p-2 text-sm shadow-sm">{renderCard(it)}</li>)}
          </ul>
        </section>
      ))}
    </div>
  );
}
